// External libraries
import React from 'react';

// Internal modules
import { appStore } from '@/store';
import { features } from '@/lib';
import { TextContainer } from './StyledComponents';
import { getContent } from '@/lib/content';
import { isUserActionCommit } from '@/lib/globals';

/**
 * Component responsible for displaying additional authorization
 * language when the user is completing a transaction in SG when
 * meeting the following cretirea:
 *
 * 1 - It is a Billing Agreement WITH purchase
 * 2 - isPaymentServiceActApplied is true
 * 3 - User action is continue
 */
export const PaymentServiceActAuthText = (): JSX.Element | null => {
  const { isBillingWithoutPurchase } = appStore.getState().api;

  if (
    features.isActive('isBillingAgreement') &&
    !isBillingWithoutPurchase &&
    features.isActive('isPaymentServiceActApplied') &&
    !isUserActionCommit()
  ) {
    return (
      <TextContainer data-testid="text-container">
        {getContent('billingAgreement.payServiceActAuthText')}
      </TextContainer>
    );
  }

  return null;
};
